import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63653be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comments-modal" }
const _hoisted_2 = { class: "comments-modal__header" }
const _hoisted_3 = { class: "comments-modal__header__top" }
const _hoisted_4 = { class: "comments-modal__title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "comments-modal__body" }
const _hoisted_7 = { class: "comments-modal__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "comments-modal__close-area",
      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.closeCommentsModal()))
    }, [
      _createElementVNode("div", {
        class: "comments-modal__container",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString($props.title), 1),
            _createElementVNode("button", {
              class: "button-close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeCommentsModal()))
            })
          ]),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ]),
        _createVNode(_component_Pagination, {
          "qt-pages": $setup.commentsPage,
          currentPage: Number(_ctx.$route.query.pageDefault) || 1,
          onChangePage: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateQuery(_ctx.$router, 'pageDefault', $event)))
        }, null, 8, ["qt-pages", "currentPage"])
      ])
    ])
  ]))
}